import React, {useCallback} from 'react';
import {JobTable, jobSearch} from 'hooks';
import {Spinner} from 'react-bootstrap';
import {Icon} from 'shared/helpers';
import {useAppContext} from 'contexts';
import styled from 'styled-components';

/*
 *Initiate search when:
 * 1. Enter is pressed
 * 2. 3 second no activity
 * 3. 3 Characters minimum
 * 4. Cancel Request, When new keypress activity
 */
const SearchBar = () => {
    const {
        resultData,
        resetResults,
        callSearch,
        searchOnText,
        searchOnButton,
        isSearching,
    } = jobSearch();
    const {sideBarOverlays, searchInput, resultReceived} = useAppContext();

    const resetResultsHandler = useCallback(
        (conditionalReset = false, forceReset = true) =>
            () => {
                if (conditionalReset) {
                    if (searchInput.current.value != '') {
                        resetResults(forceReset);
                        searchInput.current.blur();
                    }
                } else {
                    resetResults(forceReset);
                }
            },
        [resetResults]
    );

    const handleClear = useCallback((event: React.MouseEvent) => {
        // preventing default so we don't lose focus on input element
        event.preventDefault();
        searchInput.current.value = '';
    }, []);

    return (
        <>
            <div
                className={`search_overlay ${
                    sideBarOverlays ? 'overlayOn' : 'overlayOff'
                }`}
                onClick={resetResultsHandler()}
            />
            <span className="search_box">
                <div className="search-container">
                    <input
                        className={`search expandright ${searchOnText}`}
                        id={`searchright`}
                        type={`text`}
                        autoComplete={`off`}
                        placeholder={`Search Job # or Job Name`}
                        onKeyDown={callSearch}
                        ref={searchInput}
                        onBlur={resetResultsHandler(false, false)}
                    />

                    <label
                        className={`s_button searchbutton ${searchOnButton}`}
                        htmlFor="searchright"
                        onClick={resetResultsHandler(true)}>
                        <span className="mglass">
                            <Icon iconName={`search-black.svg`} />
                        </span>
                    </label>
                    <ClearButton
                        className="clear-icon"
                        onMouseDown={handleClear}>
                        <Icon
                            style={{
                                height: 18,
                            }}
                            iconName="Button-Cancel-Transparent.svg"
                        />
                    </ClearButton>

                    <div id="search_results" onKeyDown={resetResultsHandler()}>
                        {isSearching ? (
                            <div id="search_loader">
                                <div id="search_spinner">
                                    <Spinner
                                        style={{
                                            width: '15px',
                                            height: '15px',
                                            color: '#AAA',
                                        }}
                                        animation="border"
                                    />
                                    <span className="searchText">{`Searching...`}</span>
                                </div>
                            </div>
                        ) : null}

                        {resultReceived &&
                        resultData.length == 0 &&
                        sideBarOverlays ? (
                            <div id="search_message">
                                <span className="searchText">
                                    {`No records found.`}
                                </span>
                            </div>
                        ) : null}

                        {resultReceived && resultData.length > 0 ? (
                            <JobTable
                                title="Job Search"
                                jobData={resultData}
                                className="search-jobs"
                                columns={['id', 'name', 'status']}
                                link=""
                                mobileRender={true}
                                tableOrder={0}
                                tablesWithValue={1}
                                fromApi={false}
                                api=""
                            />
                        ) : null}
                    </div>
                </div>
            </span>
        </>
    );
};

const ClearButton = styled.button`
    position: absolute;
    top: 4px;
    right: 50px;
    z-index: 11;
    background: none;
    border: none;
    padding: 0;
`;

export {SearchBar};
